/**
 * La primera foto que tenga la herramienta, o null si no tiene ninguna.
 *
 * Son las fotos del equipo (`photoUrl1..3`), nunca evidencias: esas cuelgan de
 * un movimiento y retratan una entrega o un daño, no la herramienta.
 */
export const primeraFoto = (dto: {
  photoUrl1: string | null
  photoUrl2: string | null
  photoUrl3: string | null
}): string | null => dto.photoUrl1 || dto.photoUrl2 || dto.photoUrl3 || null
